<script>
import useLabor from "@/composables/financial_management/functional_information/labor/useLabor"

export default {
  async mounted() {
    await this.fetchData()
  },

  data() {
    return {
      ...useLabor().data()
    }
  },

  methods: {
    ...useLabor().methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="table-container">
      <div class="table-responsive" v-if="years?.length > 0">
        <table class="table c-table">
          <thead>
          <tr>
            <th rowspan="2" class="align-middle sticky-column">اطلاعات نیروی کار</th>
            <template v-for="year in years.slice().reverse()" :key="year">
              <th colspan="2" class="text-center">{{ year }}</th>
            </template>
          </tr>
          <tr>
            <template v-for="year in years.slice().reverse()" :key="year">
              <th class="text-center">تعداد</th>
              <th class="text-center">کل جبران خدمات پرداخت شده</th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(labor, type) in labors" :key="type">
            <td class="sticky-column">{{ type }}</td>
            <template v-for="year in years.slice().reverse()" :key="year">
              <td>
                <input
                    type="number"
                    class="form-control form-control-sm border-0 text-center"
                    v-model="labor[year].count"
                    @input="handleLaborInfoChange(type, year, labor[year].count, labor[year].services)"
                />
              </td>
              <td>
                <input
                    type="number"
                    class="form-control form-control-sm border-0 text-center"
                    v-model="labor[year].services"
                    @input="handleLaborInfoChange(type, year, labor[year].count, labor[year].services)"
                />
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="alert alert-info m-3">
        موردی وجود ندارد
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-control-sm {
  height: 2vw;
  padding: .2vw .5vw;
}

.table td, .table th {
  text-align: right;
  min-width: 10vw;
}

.table input[type="number"] {
  text-align: center;
  min-width: 9vw;
}

/* To remove the numeric Input Flash */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-responsive::-webkit-scrollbar {
  height: .6vw;
}

th.sticky-column, td.sticky-column {
  position: sticky;
  right: -.1vw;
  z-index: 3;
  box-shadow: inset .4vw 0 .4vw -.4vw rgba(255, 255, 255, 0.4);
}

tbody > tr:nth-child(odd) > td.sticky-column {
  background-color: #86d1fc;
}

tbody > tr:nth-child(even) > td.sticky-column {
  background-color: #bde6fe;
}
</style>
